module.exports = __webpack_public_path__ + "img/8_38.17434cc3.png";